import {
  COLLECTIONS_UPDATE_EXTERNAL_DATABASE_BEGIN,
  COLLECTIONS_UPDATE_EXTERNAL_DATABASE_SUCCESS,
  COLLECTIONS_UPDATE_EXTERNAL_DATABASE_FAILURE,
  COLLECTIONS_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function updateExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_EXTERNAL_DATABASE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}appwrites/${args.dbCollectionUuid}`,
        { fields: args.result, index: args.index },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_EXTERNAL_DATABASE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateExternalDatabaseError() {
  return {
    type: COLLECTIONS_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        updateExternalDatabasePending: true,
        updateExternalDatabaseError: null,
      };

    case COLLECTIONS_UPDATE_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        updateExternalDatabasePending: false,
        updateExternalDatabaseError: null,
      };

    case COLLECTIONS_UPDATE_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        updateExternalDatabasePending: false,
        updateExternalDatabaseError: action.data.error,
      };

    case COLLECTIONS_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        updateExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
